<template lang="pug">
  .club-card(
    :is="data.code ? 'router-link' : 'div'"
    :to="{name: 'Club', params: {id: data.code, data: routeData}}"
    :class="{'club-card_hover': !isEmpty}"
  )
    img.club-card__img(
      v-if="data.logoImage"
      :src="data.logoImage"
      @error="$event => $event.target.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk5AIAABIADYqAqfgAAAAASUVORK5CYII='"
      alt=""
    )
    .club-card__img(v-else)
    .club-card__content(v-show="isEmpty")
      .ph-line.mt-0(style="height: 18px;")
      .ph-line.mb-auto(style="width: 60%;")
      .ph-line(style="width: 20%; margin: 12px 0 14px;")
      div
        .ph-line(style="height: 16px; width: 22%; margin-right: 16px;")
        .ph-line(style="height: 16px; width: 50%;")
    .club-card__content(v-show="!isEmpty")
      .club-card__title(v-html="data.name" :title="data.name")
      .club-card__location(v-html="location")
      .club-card__disciplines(v-if="disciplines.length")
        .club-card__disciplines-item(
          v-for="item in disciplinesArr"
          v-show="disciplines.indexOf(item.code) !== -1"
          :key="item.code"
        )
          icon.icon(
            v-if="item.icon"
            :icon-name="item.icon"
            w="12" h="12"
          )
      .club-card__footer
        .club-card__footer-item
          .text-with-icon
            icon.icon(icon-name="user-groups" w="16" h="16")
            span {{ data.membersCount || 0 }}
        template(v-if="!hideType")
          .club-card__footer-item(v-if="data.clubPrivacy === 'private' || data.clubPrivacy === 2")
            .text-with-icon
              icon.icon(icon-name="lock" w="16" h="16")
              span Корпоративный
        .club-card__footer-item(v-if="data.isManager")
          .text-with-icon.color-success
            icon.icon(icon-name="check-bold" w="16" h="16")
            span Вы владелец
        .club-card__footer-item(v-else-if="data.isMember")
          .text-with-icon.color-success
            icon.icon(icon-name="check-bold" w="16" h="16")
            span Вы участник
</template>

<script>
import { sportTypesMixin, disciplinesMixin } from '@/assets/js/mixins'

export default {
  name: 'ClubCard',
  props: {
    data: {
      type: Object,
      required: true
    },
    isEmpty: Boolean,
    isCompact: Boolean
  },
  mixins: [sportTypesMixin, disciplinesMixin],
  data () {
    return {
      disciplinesOrder: [
        'running',
        'walking',
        'cycling',
        'swimming',
        'skiing'
      ]
    }
  },
  computed: {
    location () {
      let result = this.data.cityName || this.data.city || ''

      if (this.data.countryName) {
        result += ', ' + this.data.countryName
      }

      if (this.data.isOnline) {
        result += result ? ' • ' : ''
        result += 'Онлайн клуб'
      }
      return result
    },
    hideType () {
      return this.isCompact && (this.data.isMember || this.data.isManager)
    },
    routeData () {
      return {
        id: this.data.id,
        name: this.data.name,
        membersCount: this.data.membersCount,
        logoUrl: this.data.logoImage,
        clubPrivacy: this.data.clubPrivacy,
        isManager: this.data.isManager,
        membershipStatus: this.data.isMember ? 'clubmember' : null
      }
    },
    disciplines () {
      const sportTypes = this.data.sportTypeIds
      const result = []

      if (!sportTypes) {
        return result
      }

      for (let i = 0; i < sportTypes.length; i++) {
        const sport = sportTypes[i]
        if (this.sportTypesObj[sport] && this.sportTypesObj[sport].disciplines) {
          result.push(...this.sportTypesObj[sport].disciplines)
        }
      }

      return result
    }
  }
}
</script>

<style lang="scss" scoped>
  .ph-line {
    display: inline-block;
    vertical-align: top;
    flex: 0 0 auto;
    background-color: $bg-light;
    height: 12px;
    max-width: 100%;
    margin-top: 12px;
  }

  .club-card {
    display: flex;
    color: $color-black;
    text-decoration: none;
    @include base-sm-shadow;
    border: 1px solid map_get($color-neutral-black, 4);
    padding: 15px;
    text-align: left;
    height: 100%;
    transition: $transition-default box-shadow;

    .no-touch &_hover:hover {
      box-shadow: $elevation-deth-8;
    }

    &__img {
      flex: 0 0 auto;
      width: 80px;
      height: 80px;
      margin-right: 16px;
      object-fit: contain;

      @media (min-width: breakpoint(lg)) {
        width: 118px;
        height: 118px;
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      flex: 1 1 100%;
      min-width: 0;
    }

    &__title {
      @include text-lg;
      font-weight: $font-weight-semibold;
      margin-bottom: 4px;
      word-break: break-word;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    &__location, &__disciplines {
      @include text-xs;
    }

    &__location {
      margin-bottom: auto;
    }

    &__disciplines {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin: 16px -8px -4px 0;
    }

    &__disciplines-item {
      flex: 0 0 auto;
      margin-right: 8px;
      margin-bottom: 4px;
    }

    &__footer {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-right: -16px;
      margin-top: 16px;
      margin-bottom: -4px;
      @include text-sm;
      font-weight: $font-weight-semibold;
    }

    &__footer-item {
      margin-right: 16px;
      margin-bottom: 4px;
    }
  }
</style>
